import { render, staticRenderFns } from "./mapaPneusVeiculo.vue?vue&type=template&id=1d8a2dfa&scoped=true"
import script from "./mapaPneusVeiculo.vue?vue&type=script&lang=js"
export * from "./mapaPneusVeiculo.vue?vue&type=script&lang=js"
import style0 from "./mapaPneusVeiculo.vue?vue&type=style&index=0&id=1d8a2dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a2dfa",
  null
  
)

export default component.exports